export default __webpack_public_path__ + "static/media/paint-palette.be1e5b3b.png";